import { useState, useCallback } from "react";
import { DropdownMenu } from "../DropdownMenu";
import { useTranslation } from "react-i18next";
import { SelectChangeEvent } from "@mui/material/Select/Select";
import { IShiftDropdownProps } from "./ShiftDropdownInterfaces";

export enum ShiftOptionsEnum {
    current = "current",
    previous = "previous",
}

export const ShiftDropdown = ({ shift, handleShift, bigSize }: IShiftDropdownProps) => {
    const { t, i18n } = useTranslation();
    const [dropdownValue, setDropdownValue] = useState(shift ? shift : t(ShiftOptionsEnum.current));

    const tKeys = {
        base: "shift_dropdown",
        title: "title",
        optionsHolder: "shift_options",
        key: "option",
    };

    const shiftOptions =
        i18n.language.slice(0, 2) === "en"
            ? [
                  { id: ShiftOptionsEnum.current, name: "Current shift" },
                  { id: ShiftOptionsEnum.previous, name: "Previous shift" },
              ]
            : i18n.language.slice(0, 2) === "fr"
            ? [
                  { id: ShiftOptionsEnum.current, name: "Poste actuel" },
                  { id: ShiftOptionsEnum.previous, name: "Poste précédent" },
              ]
            : [
                  { id: ShiftOptionsEnum.current, name: "Turno actual" },
                  { id: ShiftOptionsEnum.previous, name: "Turno anterior" },
              ];

    const handleChange = useCallback(
        (event: SelectChangeEvent<string>): void => {
            setDropdownValue(event?.target.value);
            handleShift(event?.target.value as ShiftOptionsEnum);
        },
        [handleShift],
    );

    return (
        <div>
            <DropdownMenu
                dropdownValue={dropdownValue}
                handleChange={handleChange}
                tKeys={tKeys}
                options={shiftOptions}
                bigSize={bigSize}
            />
        </div>
    );
};
